import { formatNumberForTable } from "@/Utils/formatFunctions";
import { useTrans } from "@/translations";

import type { ContributionSliceData } from "../types";

type Props = {
  hoverIndex: number | null;
  setHoverIndex: (value: number | null) => void;
  data: ContributionSliceData[];
};

export const TenantContributionLegend: React.FC<Props> = ({
  hoverIndex,
  setHoverIndex,
  data,
}) => {
  const { t } = useTrans();
  return (
    <div className="@container grid w-full grid-cols-2 gap-x-[16.5px] gap-y-[3.3px]">
      {data.map((d, i) => (
        <div
          key={d.label}
          onMouseEnter={() => setHoverIndex(i)}
          onMouseLeave={() => setHoverIndex(null)}
          className="flex w-full cursor-default items-center justify-between gap-[4.95px] py-[1.65px] text-[12px] transition-opacity"
          style={{
            opacity: hoverIndex == null || hoverIndex === i ? 1 : 0.4,
          }}
        >
          <span className="flex min-w-0 flex-1 items-center gap-[4.95px]">
            <span
              className="inline-block h-[9px] w-[9px] flex-none rounded-sm"
              style={{ background: d.color }}
            />
            <span className="truncate">
              {d.label}{" "}
              <span className="text-grey4 text-[10px]">
                {d.isDeleted && `(${t("common:deleted")})`}
              </span>
            </span>
          </span>
          <span className="text-grey6 hidden flex-none font-semibold @min-[400px]:inline">
            {formatNumberForTable(d.pct, { numDecimals: 0 })}%
          </span>
        </div>
      ))}
    </div>
  );
};
